export const organizationAdminsKeys = {
  all: ['organization-admins'],
  lists: () => [...organizationAdminsKeys.all, 'list'],
  list: () => [...organizationAdminsKeys.lists()],
} as const;
